import { StarFourPointsBoxOutlineIcon } from './StarFourPointsBoxOutlineIcon';

/**
 * author: Jeff Anders
 * id CB3E6FC0-B9F1-4CAE-AAB9-72946D7E7064
 * name star-four-points-box-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-four-points-box-outline.svg
 * tags
 * - Shape 
 */
export const AutoBoxOutlineIcon = StarFourPointsBoxOutlineIcon;
export default AutoBoxOutlineIcon